/**
 * BrickBox Storefront UI Interactions
 * Extracted and unified from Updated Design specifications.
 */

document.addEventListener('DOMContentLoaded', function () {
  /* 0. Phone: only the Categories + search row stays pinned while scrolling.
     The whole header is sticky, so its top is pulled up by the height of the rows above the search. */
  (function initPinnedSearch() {
    var stick = document.querySelector('.stick'),
        srch = stick && stick.querySelector('.srch');
    if (!stick || !srch) return;
    var mq = window.matchMedia('(max-width:640px)');
    function measure() {
      if (!mq.matches) {
        stick.style.removeProperty('top');
        document.documentElement.style.removeProperty('--hdr-h');
        return;
      }
      var above = srch.getBoundingClientRect().top - stick.getBoundingClientRect().top;
      stick.style.top = (8 - Math.max(0, Math.round(above))) + 'px';
      document.documentElement.style.setProperty('--hdr-h', Math.round(stick.offsetHeight - above) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (mq.addEventListener) mq.addEventListener('change', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(stick);
  })();

  /* 1. Numbers counter animation */
  (function initCounters() {
    var g = document.getElementById('numgrid');
    if (!g || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ns = g.querySelectorAll('.n'), done = false;
    ns.forEach(function (n) {
      n.textContent = '0' + (n.getAttribute('data-suf') || '');
    });
    new IntersectionObserver(function (es, ob) {
      es.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true;
        ob.disconnect();
        ns.forEach(function (n) {
          var to = parseInt(n.getAttribute('data-to'), 10) || 0, t0 = null, dur = 1100;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            n.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + (n.getAttribute('data-suf') || '');
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.4 }).observe(g);
  })();

  /* 2. Brands and Support: tap to open on touch screens, tablet and mobile */
  (function initHeaderDropdowns() {
    var mq = window.matchMedia('(max-width:900px),(hover:none)');
    var dds = [].slice.call(document.querySelectorAll('.bar1 .dd'));
    var nav = document.getElementById('mnavT');
    function closeAll(except) {
      dds.forEach(function (d) {
        if (d === except) return;
        d.classList.remove('open');
        var dt = d.querySelector('.dt');
        if (dt) dt.setAttribute('aria-expanded', 'false');
      });
    }
    dds.forEach(function (d) {
      var t = d.querySelector('.dt');
      if (!t) return;
      t.setAttribute('aria-haspopup', 'true');
      t.setAttribute('aria-expanded', 'false');
      t.addEventListener('click', function (e) {
        if (!mq.matches) return;
        e.preventDefault();
        var open = !d.classList.contains('open');
        closeAll(d);
        d.classList.toggle('open', open);
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && nav) nav.checked = false;
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.bar1 .dd')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    if (nav) nav.addEventListener('change', function () {
      if (nav.checked) closeAll();
    });
  })();

  /* 3. Banner carousel: works in any [data-carousel] slot */
  (function initCarousels() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-carousel]').forEach(function (c) {
      var tr = c.querySelector('.bc-track') || c.querySelector('.hd-track');
      if (!tr) return;
      var slides = [].slice.call(tr.children), n = slides.length,
          wrap = c.querySelector('.bc-dots') || c.querySelector('.hd-dots'),
          arrows = c.querySelector('.bc-arrows') || c.querySelector('.hd-arrows'),
          dots = [], cur = 0, hold = false, timer, resume, raf;

      if (n < 2) {
        if (wrap) wrap.hidden = true;
        if (arrows) arrows.hidden = true;
        return;
      }
      function go(i) {
        cur = (i + n) % n;
        tr.scrollTo({ left: cur * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      function restart() {
        clearInterval(timer);
        if (reduce) return;
        timer = setInterval(function () {
          if (!hold && !document.hidden) go(cur + 1);
        }, 5000);
      }
      if (wrap && wrap.children.length === 0) {
        slides.forEach(function (sl, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Banner ' + (k + 1) + ' of ' + n);
          b.addEventListener('click', function () { go(k); restart(); });
          wrap.appendChild(b);
          dots.push(b);
        });
      } else if (wrap) {
        dots = [].slice.call(wrap.querySelectorAll('button'));
        dots.forEach(function (b, k) {
          b.addEventListener('click', function () { go(k); restart(); });
        });
      }
      function mark() {
        cur = Math.max(0, Math.min(n - 1, Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth))));
        dots.forEach(function (d, k) {
          d.setAttribute('aria-selected', k === cur ? 'true' : 'false');
          d.classList.toggle('on', k === cur);
        });
        slides.forEach(function (sl, k) {
          sl.setAttribute('aria-hidden', k === cur ? 'false' : 'true');
          sl.tabIndex = k === cur ? 0 : -1;
        });
      }
      tr.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(mark);
      }, { passive: true });

      var p = c.querySelector('.bc-prev') || c.querySelector('.hd-prev'),
          nx = c.querySelector('.bc-next') || c.querySelector('.hd-next');
      if (p) p.addEventListener('click', function () { go(cur - 1); restart(); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); restart(); });
      c.addEventListener('mouseenter', function () { hold = true; });
      c.addEventListener('mouseleave', function () { hold = false; });
      tr.addEventListener('touchstart', function () {
        hold = true;
        clearTimeout(resume);
      }, { passive: true });
      tr.addEventListener('touchend', function () {
        resume = setTimeout(function () { hold = false; }, 4000);
      }, { passive: true });
      window.addEventListener('resize', function () { tr.scrollLeft = cur * tr.clientWidth; });
      mark();
      restart();
    });
  })();

  /* 4. Delivery location: pincode check (Lucknow 90 min) */
  (function initLocationChecker() {
    var FAST = { prefixes: ['226'], pins: [], eta: '90 min', area: 'Lucknow' };
    var root = document.querySelector('[data-loc]');
    if (!root) return;
    var btn = root.querySelector('.loc-btn'), form = root.querySelector('.lp-f');
    if (!btn || !form) return;
    var input = form.querySelector('input'),
        res = root.querySelector('.lp-r'),
        la = root.querySelector('.loc-a'),
        lp = root.querySelector('.loc-p'),
        nav = document.getElementById('mnavT');

    function status(pin) {
      if (!/^[1-9][0-9]{5}$/.test(pin)) return 'err';
      if (FAST.pins.indexOf(pin) > -1) return 'ok';
      for (var i = 0; i < FAST.prefixes.length; i++) {
        if (pin.indexOf(FAST.prefixes[i]) === 0) return 'ok';
      }
      return 'no';
    }
    function paint(pin, st) {
      root.setAttribute('data-state', st || 'lko');
      if (st === 'no') {
        if (la) la.textContent = 'Not deliverable';
        if (lp) lp.textContent = pin;
      } else {
        if (la) la.textContent = 'Delivery in ' + FAST.eta;
        if (lp) lp.textContent = pin || FAST.area;
      }
      btn.setAttribute('aria-label', 'Delivery location: ' + (pin || FAST.area) + ', ' + (la ? la.textContent : '') + '. Change pincode');
    }
    function openModal(o) {
      root.classList.toggle('open', o);
      btn.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (o) {
        if (nav) nav.checked = false;
        setTimeout(function () {
          if (input) {
            try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
          }
        }, 60);
      }
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      openModal(!root.classList.contains('open'));
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) openModal(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') openModal(false);
    });
    if (nav) nav.addEventListener('change', function () {
      if (nav.checked) openModal(false);
    });
    if (input) {
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '').slice(0, 6);
        if (v !== input.value) input.value = v;
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input) return;
      var pin = input.value.trim(), st = status(pin);
      if (res) {
        res.className = 'lp-r ' + st;
        if (st === 'err') {
          res.textContent = 'Please enter a valid 6-digit pincode.';
          return;
        }
        if (st === 'ok') {
          res.textContent = 'Yes, we deliver to ' + pin + '. Expect your order in about ' + FAST.eta + '.';
        } else {
          res.innerHTML = 'Sorry, we only deliver within ' + FAST.area + ' for now, and ' + pin + ' is outside it. Ordering for a project? <a href="/pages/bulk-orders">Talk to us</a>.';
        }
      }
      paint(pin, st);
      try { localStorage.setItem('bb_pin', pin); } catch (err) {}
    });
    var saved = null;
    try { saved = localStorage.getItem('bb_pin'); } catch (err) {}
    if (saved && status(saved) !== 'err') {
      if (input) input.value = saved;
      paint(saved, status(saved));
    } else {
      paint('', 'lko');
    }
    /* the cart's own pincode check tells the header too */
    window.addEventListener('bb:pin', function (e) {
      var v = e.detail;
      if (!v || status(v) === 'err') return;
      if (input) input.value = v;
      paint(v, status(v));
    });
  })();

  /* 5. Deal of the day countdown: runs to midnight, local time */
  (function initCountdown() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    function pad(v) { return (v < 10 ? '0' : '') + v; }
    function tick() {
      var now = new Date(), end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var t = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60);
      els.forEach(function (e) { e.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* 6. Tablet & Phone swipeable brand strip */
  (function initBrandMarquee() {
    var bmq = document.querySelector('.bmq');
    if (!bmq) return;
    var track = bmq.querySelector('.bmq-track');
    if (!track) return;
    var sets = track.querySelectorAll('.bset');
    if (sets.length < 2) return;
    var mq = window.matchMedia('(max-width:1080px),(hover:none)'),
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = document.querySelector('.bidx'),
        marks = idx ? [].slice.call(idx.querySelectorAll('a')) : [];
    var SPEED = reduce ? 0 : 30, on = false, setW = 0, pos = 0, hold = false,
        touching = false, resume, last = 0, lastMark = 0, perSet = sets[0].children.length;

    var third = sets[1].cloneNode(true);
    third.setAttribute('aria-hidden', 'true');
    [].forEach.call(third.querySelectorAll('a'), function (x) { x.setAttribute('tabindex', '-1'); });
    [].forEach.call(sets[1].querySelectorAll('a'), function (x) { x.setAttribute('tabindex', '-1'); });
    track.appendChild(third);
    sets = track.querySelectorAll('.bset');

    function measure() { setW = sets[1].offsetLeft - sets[0].offsetLeft; }
    function wrap() {
      var hi = Math.min(2 * setW, bmq.scrollWidth - bmq.clientWidth - 2);
      if (pos < setW * 0.5) pos += setW; else if (pos >= hi) pos -= setW;
    }
    function pause(ms) {
      hold = true;
      clearTimeout(resume);
      resume = setTimeout(function () { hold = false; pos = bmq.scrollLeft; }, ms);
    }
    function mark() {
      if (!marks.length) return;
      var r = bmq.getBoundingClientRect(), cx = r.left + r.width / 2, best = 1e9, pick = 0;
      [].forEach.call(track.querySelectorAll('.blog'), function (el, i) {
        var b = el.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - cx);
        if (d < best) { best = d; pick = i % perSet; }
      });
      marks.forEach(function (m, i) { m.classList.toggle('on', i === pick); });
    }
    function enable() {
      on = mq.matches;
      bmq.classList.toggle('swipe', on);
      if (on) { measure(); pos = setW; bmq.scrollLeft = pos; mark(); }
      else { bmq.scrollLeft = 0; marks.forEach(function (m) { m.classList.remove('on'); }); }
    }
    function frame(t) {
      if (on) {
        var dt = Math.min(64, t - (last || t));
        if (!hold && !document.hidden && SPEED) {
          pos += SPEED * dt / 1000;
          wrap();
          bmq.scrollLeft = pos;
        }
        if (t - lastMark > 180) { mark(); lastMark = t; }
      }
      last = t;
      requestAnimationFrame(frame);
    }
    bmq.addEventListener('touchstart', function () { touching = true; pause(1e9); }, { passive: true });
    bmq.addEventListener('touchend', function () { touching = false; pause(2500); }, { passive: true });
    bmq.addEventListener('wheel', function () { pause(2500); }, { passive: true });
    bmq.addEventListener('scroll', function () {
      if (!on || !hold) return;
      pos = bmq.scrollLeft;
      if (!touching) { var p = pos; wrap(); if (p !== pos) bmq.scrollLeft = pos; }
    }, { passive: true });
    marks.forEach(function (m, i) {
      m.addEventListener('click', function (e) {
        if (!on) return;
        e.preventDefault();
        var r = bmq.getBoundingClientRect(), best = null;
        [].forEach.call(sets, function (set) {
          var card = set.children[i];
          if (!card) return;
          var b = card.getBoundingClientRect();
          var target = bmq.scrollLeft + (b.left - r.left) - (r.width - b.width) / 2;
          if (target >= 0 && target <= bmq.scrollWidth - bmq.clientWidth && (best === null || Math.abs(target - bmq.scrollLeft) < Math.abs(best - bmq.scrollLeft))) {
            best = target;
          }
        });
        if (best === null) return;
        pause(3500);
        bmq.scrollTo({ left: best, behavior: 'smooth' });
      });
    });
    window.addEventListener('resize', function () {
      if (on) { measure(); pos = bmq.scrollLeft; wrap(); bmq.scrollLeft = pos; }
    });
    if (mq.addEventListener) mq.addEventListener('change', enable);
    enable();
    requestAnimationFrame(frame);
  })();

  /* 7. PDP: Earn Cashback Popup Modal */
  (function initEarnPopup() {
    document.querySelectorAll('.earn').forEach(function (earn) {
      var btn = earn.querySelector('.earn-q');
      var pop = earn.querySelector('.earn-pop');
      if (!btn || !pop) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = pop.hasAttribute('hidden');
        if (open) {
          pop.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          pop.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('click', function (e) {
        if (!earn.contains(e.target)) {
          pop.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          pop.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();

  /* 8. Copy Order Number helper */
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          btn.classList.add('copied');
          setTimeout(function () { btn.classList.remove('copied'); }, 2000);
          if (window.bbToast) window.bbToast('Order number ' + text + ' copied');
        });
      }
    });
  });

  /* 9. Phone: the logo row and delivery line scroll away, the search bar stays pinned */
  (function initStickySearchPhone() {
    var st = document.querySelector('.stick'), sr = st && st.querySelector('.srch');
    if (!st || !sr) return;
    var mq = window.matchMedia('(max-width:640px)');
    function set() {
      if (mq.matches) {
        var off = sr.getBoundingClientRect().top - st.getBoundingClientRect().top - 8;
        st.style.top = (-Math.max(0, Math.round(off))) + 'px';
      } else {
        st.style.top = '';
      }
    }
    set();
    window.addEventListener('resize', set);
    if (mq.addEventListener) mq.addEventListener('change', set);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
  })();

  /* 10. Product-card ADD button and its plus/minus stepper.
      The cart on the server is the only truth. Every card that sells a variant
      already in the cart shows the stepper with the real quantity (also after a
      reload, and on every other card of the same product); a variant that is
      not in the cart shows ADD. A tap updates the number at once, taps are sent
      one after another, and the numbers are corrected from /cart.js afterwards,
      so a refused change (no more stock, offline) never leaves a wrong number.
      A card without data-variant-id (a product with options) opens its page. */
  (function initCardCart() {
    var CARD_BUTTONS = '.pc-add[data-variant-id], .pc-qty[data-variant-id]';
    var serverQty = {};   // variant id -> quantity the cart really holds
    var shownQty = {};    // variant id -> quantity the cards show (ahead of serverQty while a tap is in flight)
    var inFlight = {};    // variant id -> taps not yet settled
    var chain = {};       // variant id -> promise, so taps reach the server in order

    function toast(message) { if (window.bbToast) window.bbToast(message); }

    function setBadges(count) {
      document.querySelectorAll('.ibtn .cnt, .mtab .mt-cart i, [data-cart-count]')
        .forEach(function (el) { el.textContent = count; });
    }

    function nameOf(el) {
      var own = el.getAttribute('data-name');
      if (own) return own;
      return (el.getAttribute('aria-label') || '').replace(/^Add\s+/i, '').replace(/\s+to cart$/i, '') || 'this product';
    }

    function makeAdd(vid, name) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'pc-add';
      a.setAttribute('data-variant-id', vid);
      a.setAttribute('data-name', name);
      a.setAttribute('aria-label', 'Add ' + name + ' to cart');
      a.textContent = 'ADD';
      return a;
    }

    function makeStepper(vid, qty, name) {
      var box = document.createElement('span');
      box.className = 'pc-qty';
      box.setAttribute('data-variant-id', vid);
      box.setAttribute('data-name', name);
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', 'Quantity of ' + name + ' in your cart');

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'q-m';
      minus.setAttribute('aria-label', 'Decrease quantity of ' + name);
      minus.innerHTML = '&minus;';

      var count = document.createElement('b');
      count.setAttribute('aria-live', 'polite');
      count.textContent = qty;

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'q-p';
      plus.setAttribute('aria-label', 'Increase quantity of ' + name);
      plus.textContent = '+';

      box.appendChild(minus);
      box.appendChild(count);
      box.appendChild(plus);
      return box;
    }

    /* Make every card agree with shownQty. Safe to run any number of times. */
    function paint() {
      var els = document.querySelectorAll(CARD_BUTTONS);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var vid = el.getAttribute('data-variant-id');
        var qty = shownQty[vid] || 0;
        if (el.classList.contains('pc-add')) {
          if (qty > 0) el.replaceWith(makeStepper(vid, qty, nameOf(el)));
        } else if (qty > 0) {
          var count = el.querySelector('b');
          if (count && count.textContent !== String(qty)) count.textContent = qty;
        } else {
          el.replaceWith(makeAdd(vid, nameOf(el)));
        }
      }
    }

    function applyCart(cart) {
      var seen = {};
      cart.items.forEach(function (item) {
        var vid = String(item.variant_id);
        seen[vid] = true;
        serverQty[vid] = item.quantity;
        if (!inFlight[vid]) shownQty[vid] = item.quantity;
      });
      Object.keys(serverQty).forEach(function (vid) {
        if (seen[vid]) return;
        serverQty[vid] = 0;
        if (!inFlight[vid]) shownQty[vid] = 0;
      });
      setBadges(cart.item_count);
      paint();
      document.dispatchEvent(new CustomEvent('bb:cart', { detail: { cart: cart } }));
      return cart;
    }

    function refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(applyCart)
        .catch(function () { /* offline: keep what the page rendered */ });
    }
    window.bbSyncCartBadge = refresh;
    window.bbCartQty = function (vid) { return serverQty[String(vid)] || 0; };

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .catch(function () { return { ok: false, data: { description: 'Network problem. Please try again.' } }; });
    }

    /* Ask for an exact quantity of one variant. */
    function setQuantity(vid, target) {
      shownQty[vid] = target;
      inFlight[vid] = (inFlight[vid] || 0) + 1;
      paint();

      var latest = target;
      chain[vid] = (chain[vid] || Promise.resolve()).then(function () {
        var have = serverQty[vid] || 0;
        latest = shownQty[vid];
        if (latest === have) return null;
        var request = have === 0
          ? post('/cart/add.js', { items: [{ id: Number(vid), quantity: latest }] })
          : post('/cart/change.js', { id: String(vid), quantity: latest });
        return request.then(function (res) {
          if (!res.ok) {
            toast(res.data.description || res.data.message || 'Could not update your cart.');
            return null;
          }
          if (have === 0) toast('Added to cart');
          serverQty[vid] = latest;
          return null;
        });
      }).then(function () {
        inFlight[vid] -= 1;
        if (inFlight[vid] === 0) return refresh();
      });
    }

    document.addEventListener('click', function (e) {
      var add = e.target.closest('.pc-add');
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute('data-variant-id');
        if (!vid) {
          var card = add.closest('.pc, .ws, article');
          var link = add.getAttribute('href') || (card && card.querySelector('a[href^="/products/"]') || {}).href;
          if (link) { window.location.href = link; return; }
          toast('Open the product to choose options.');
          return;
        }
        var cardOfAdd = add.closest('.pc');
        setQuantity(vid, (shownQty[vid] || 0) + 1);
        var plus = cardOfAdd && cardOfAdd.querySelector('.pc-qty .q-p');
        if (plus) plus.focus({ preventScroll: true });
        return;
      }

      var btn = e.target.closest('.pc-qty button');
      if (!btn) return;
      e.preventDefault();
      var box = btn.parentNode;
      var id = box.getAttribute('data-variant-id');
      var holder = box.closest('.pc');
      var next = Math.max(0, (shownQty[id] || 0) + (btn.classList.contains('q-p') ? 1 : -1));
      setQuantity(id, next);
      if (next === 0 && holder) {
        var back = holder.querySelector('.pc-add');
        if (back) back.focus({ preventScroll: true });
      }
    });

    /* Cards that arrive later (sections, filters, quick add) pick up the cart too. */
    var paintTimer = 0;
    new MutationObserver(function () {
      clearTimeout(paintTimer);
      paintTimer = setTimeout(paint, 60);
    }).observe(document.body, { childList: true, subtree: true });

    /* Another tab or the cart page changed the cart. */
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    refresh();
  })();

  /* 11. Phone: promo banners glide along on their own, one every 3 seconds, in an endless loop */
  (function initMobilePromoGlide() {
    var row = document.querySelector('.bnr-row');
    if (!row) return;
    var mq = window.matchMedia('(max-width:640px)'),
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var real = [].slice.call(row.children), n = real.length, built = false, hold = false,
        touching = false, resume, settle;
    if (n < 2) return;
    function all() { return [].slice.call(row.children); }
    function clone(el) {
      var c = el.cloneNode(true);
      c.classList.add('bnr-clone');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      /* A clone copies whatever the scroll-reveal left inline on the original.
         If it is taken before that tile has revealed, the copy keeps
         opacity:0 forever, because the reveal only knows the originals. */
      ['opacity', 'transform', 'translate', 'rotate', 'scale'].forEach(function (prop) {
        c.style.removeProperty(prop);
      });
      return c;
    }
    function centreOf(el) { return el.offsetLeft - (row.clientWidth - el.offsetWidth) / 2; }
    function current() {
      var cx = row.scrollLeft + row.clientWidth / 2, idx = 0, best = 1e9;
      all().forEach(function (el, i) {
        var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - cx);
        if (d < best) { best = d; idx = i; }
      });
      return idx;
    }
    function jumpTo(i) {
      var el = all()[i];
      if (!el) return;
      row.style.scrollSnapType = 'none';
      row.style.scrollBehavior = 'auto';
      row.scrollLeft = centreOf(el);
      void row.offsetWidth;
      row.style.scrollSnapType = '';
      row.style.scrollBehavior = '';
    }
    function loopFix() {
      if (touching) return;
      var i = current();
      if (i < n) jumpTo(i + n);
      else if (i >= 2 * n) jumpTo(i - n);
    }
    function build() {
      if (built || !mq.matches) return;
      built = true;
      real.forEach(function (el) { row.insertBefore(clone(el), real[0]); });
      real.forEach(function (el) { row.appendChild(clone(el)); });
      jumpTo(n);
    }
    function step() {
      if (!built || !mq.matches || hold || document.hidden) return;
      var nx = all()[current() + 1];
      if (!nx) return;
      row.scrollTo({ left: centreOf(nx), behavior: 'smooth' });
    }
    row.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(loopFix, 140);
    }, { passive: true });
    row.addEventListener('touchstart', function () {
      touching = true;
      hold = true;
      clearTimeout(resume);
    }, { passive: true });
    row.addEventListener('touchend', function () {
      touching = false;
      clearTimeout(settle);
      settle = setTimeout(loopFix, 140);
      resume = setTimeout(function () { hold = false; }, 3500);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (built && mq.matches) jumpTo(n + (current() % n));
    });
    if (mq.addEventListener) mq.addEventListener('change', build);
    else if (mq.addListener) mq.addListener(build);
    build();
    if (!reduce) setInterval(step, 3000);
  })();

  /* 12. PDP: Sticky Add to Cart Bar */
  (function initStickyATC() {
    var row = document.getElementById('cartrow'), bar = document.getElementById('satc');
    if (!row || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: '0px 0px -30% 0px' }).observe(row);
  })();

  /* 13. PDP: Bulk Pricing, Quantity Stepper, and Free Delivery Progress */
  (function initPDPBulkQty() {
    /* The live product page (brickbox-pdp-live) runs its own stepper and meter from real variant prices. */
    if (document.getElementById('bbProductForm')) return;
    var fmt = function (n) { return 'Rs. ' + n.toLocaleString('en-IN'); };
    var qtyIn = document.querySelector('.qty input');
    var cards = [].slice.call(document.querySelectorAll('.bulkcard'));
    var FREE = 10000, fd = document.getElementById('fdel'), fdTx = document.getElementById('fdelTx');
    var fdRow = document.getElementById('fdrow'), fdStat = document.getElementById('fdStat'), fdSub = document.getElementById('fdSub');
    var echo = document.getElementById('qtyEcho'), total = document.getElementById('lineTotal'), satcP = document.getElementById('satcPrice');

    function tierFor(q) {
      var t = cards[0];
      cards.forEach(function (c) { if (q >= +c.dataset.min) t = c; });
      return t;
    }
    function render() {
      if (!qtyIn) return;
      var q = Math.max(1, parseInt(qtyIn.value, 10) || 1);
      qtyIn.value = q;
      if (cards.length) {
        var t = tierFor(q), unit = +t.dataset.price;
        cards.forEach(function (c) { c.classList.toggle('on', c === t); });
        if (echo) echo.textContent = q;
        if (total) total.textContent = fmt(unit * q);
        if (satcP) satcP.textContent = fmt(unit);
      }
      if (fd) {
        var curPrice = (cards.length && tierFor(q)) ? +tierFor(q).dataset.price : (parseInt(qtyIn.dataset.price, 10) || 399);
        var tot = curPrice * q, left = FREE - tot;
        fd.style.setProperty('--fp', Math.min(100, Math.round(tot / FREE * 100)) + '%');
        fd.classList.toggle('done', left <= 0);
        if (fdTx) fdTx.innerHTML = left > 0 ? 'Add <b>' + fmt(left) + '</b> more for free delivery in Lucknow' : 'You get free delivery in Lucknow on this order';
        if (fdRow) {
          fdRow.classList.toggle('done', left <= 0);
          if (fdStat) {
            fdStat.classList.toggle('pend', left > 0);
            fdStat.textContent = left > 0 ? fmt(left) + ' to go' : 'FREE';
          }
          if (fdSub) fdSub.textContent = left > 0 ? 'Add ' + fmt(left) + ' more to unlock' : 'Unlocked on this order';
        }
      }
    }
    if (qtyIn) {
      var btns = document.querySelectorAll('.qty button');
      if (btns[0]) btns[0].addEventListener('click', function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) - 1); render(); });
      if (btns[1]) btns[1].addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) + 1; render(); });
      qtyIn.addEventListener('input', render);
      cards.forEach(function (c) { c.addEventListener('click', function () { qtyIn.value = c.dataset.min; render(); qtyIn.focus(); }); });
      render();
    }
  })();

  /* 14. Global Toast notification helper */
  window.bbToast = function (msg, undo) {
    var t = document.querySelector('.bb-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'bb-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    var s = document.createElement('span');
    s.textContent = msg;
    t.appendChild(s);
    if (undo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = 'Undo';
      b.onclick = function () { undo(); t.classList.remove('on'); };
      t.appendChild(b);
    }
    t.classList.add('on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('on'); }, 4200);
  };

  /* 14b. Cart: fade the row out before the removal navigates away.
     The design transitions .ck-it to opacity 0 via a .gone class; our rows
     remove through a plain /cart/change link, so the fade never had a chance
     to play. Hold the navigation for the length of the transition. */
  (function initCartRemoveFade() {
    var list = document.querySelector('.ck-list, .template-cart .ck-it');
    if (!list && !document.querySelector('.ck-it')) return;

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.ck-rm');
      if (!rm || !rm.getAttribute('href')) return;
      var row = rm.closest('.ck-it');
      if (!row || row.classList.contains('gone')) return;

      e.preventDefault();
      row.classList.add('gone');

      var href = rm.getAttribute('href'), left = false;
      function go() {
        if (left) return;
        left = true;
        window.location.href = href;
      }
      row.addEventListener('transitionend', go, { once: true });
      setTimeout(go, 400); /* in case the transition never fires */
    });
  })();

  /* 15. Cross-browser Scroll Reveal Observer (fallback when animation-timeline is unsupported) */
  (function initScrollRevealFallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.ctile, .bnr-tile, .t4v, .stmt span').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var supportsTimeline = false;
    try {
      supportsTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');
    } catch (e) {}

    var targets = document.querySelectorAll('.ctile, .bnr-tile, .t4v, .stmt span');
    if (!targets.length) return;

    if (!supportsTimeline && 'IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            ob.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      targets.forEach(function (t) {
        ob.observe(t);
      });
    } else if (supportsTimeline) {
      targets.forEach(function (t) {
        t.classList.add('is-revealed');
      });
    }
  })();
});
